import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ICustomer } from 'src/app/domain/customer/ICustomer';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { ParcelOriginIdEnum } from 'src/app/domain/registration/enums/parcel-origin.enum';
import {
  ParcelTypeEnum,
  ParcelTypeIdEnum,
} from 'src/app/domain/registration/enums/parcel-type.enum';
import { getSystemTypeDescriptionByValue } from 'src/app/domain/registration/enums/system-type.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { ICustomerParcel } from 'src/app/domain/registration/models/ICustomerParcel';
import { AbstractCrudCES } from 'src/app/shared/components/crud/abstract-crud-ces';
import { DialogConfirmComponent } from 'src/app/shared/components/dialog-confirm/dialog-confirm.component';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { SlipService } from 'src/app/views/registration/charges/components/slip-dialog/slip.service';
import { GlobalConfigService } from 'src/app/views/registration/shared/global-config/crud-service';
import { ReasonDialog } from 'src/app/views/registration/shared/reason-dialog/reason-dialog.component';
import { CustomerService } from '../../../customers/crud-service';
import { CES_CONFIG_FIELDS, TABLE_CONFIG_COLUMNS } from '../crud-config';
import { CustomerParcelService } from '../crud-service';
import { API_PATH } from 'src/environments/environment';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { lastValueFrom } from 'rxjs';
import { GlobalConfigOriginEnum } from 'src/app/domain/registration/enums/global-config.enum';

@Component({
  selector: 'app-generarte-parcels-ces',
  templateUrl: './crud-ces.component.html',
  styleUrls: ['./crud-ces.component.sass'],
})
export class CustomerParcelCESComponent
  extends AbstractCrudCES<ICustomerParcel>
  implements OnInit, OnDestroy {
  isGeneratingBoletos = false;
  boletoProgressMessage = '';
  downloadProgress = 0;
  downloadTotal = 0;
  processedBoletos = 0;
  isDownloading = false;
  totalBoletos = 0;
  boletoProgressPercentage = 0;
  @ViewChild(MatTable) table: MatTable<any>;
  override config: IFieldConfig[] = CES_CONFIG_FIELDS;
  override data: ICustomerParcel;
  type: TypeCesEnum;
  override title = '--';

  displayedColumns = [
    'type',
    'parcel',
    'emissionDate',
    'dueDate',
    'value',
    'fees',
    'fine',
    'discountValue',
    'total',
    'actions',
  ];
  configColumns = TABLE_CONFIG_COLUMNS;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  length: 0;
  params: any = { limit: 10, page: 0, filter: '' };
  customerId: string = '';
  customer: ICustomer;
  customerPlans: any[] = [];
  systemSelected: any;
  typeSub: Subscription | undefined;
  showSelectPlan: boolean = false;
  parcelType: ParcelTypeEnum;
  planSelect: any;

  private originalInterestPercent: number = 0;
  private originalFineValue: number = 0;

  override get typeCesEnum() {
    return TypeCesEnum;
  }

  setFields() {
    if (this.parcelType === ParcelTypeEnum.MANUAL) {
      this.form.get('type')?.setValue(ParcelTypeEnum.MANUAL);
    }
  }

  constructor(
    public dialogRef: MatDialogRef<CustomerParcelCESComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      type: TypeCesEnum;
      customerId: string;
      element: ICustomerParcel;
      parcelType: ParcelTypeEnum;
    },
    private cdr: ChangeDetectorRef,
    fb: FormBuilder,
    private customerService: CustomerService,
    private service: CustomerParcelService,
    public dialog: MatDialog,
    private ecr: ChangeDetectorRef,
    private toastService: ToastService,
    private globalConfigService: GlobalConfigService,
    private slipService: SlipService
  ) {
    super(fb);

    this.customerId = data.customerId;
    this.title = `${this.typeCes} ${this.service.title.toUpperCase()}`;
    this.type = data.type;
    this.data = data.element;
    this.title = this.type;
    this.parcelType = data.parcelType;
  }

  override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.loadGlobalConfig();

    await this.customerService.get(this.customerId).subscribe((data: any) => {
      this.customer = data;

      console.log('📋 Cliente carregado:', {
        id: data.id,
        name: data.name || data.companyName,
        cep: data.cep,
        address: data.address,
        city: data.city,
        state: data.state,
        document: data.cpf || data.cnpj,
      });

      this.customerPlans = data.customerPlans.filter(
        (item: any) => item.active && item.canceledAt === null
      );

      let customerPlansTmp = this.customerPlans.map((item: any) => {
        item.type = getSystemTypeDescriptionByValue(item.system.type);
        // item.system = item.system?.name;

        return item;
      });

      this.getFieldConfig('plan').componentData = {
        params: { plans: customerPlansTmp },
      };

      this.form.get('totalPaidValue')?.disable();
    });

    this.typeSub = this.form.get('type')?.valueChanges.subscribe((value) => {
      this.showSelectPlan =
        value === ParcelTypeEnum.MONTHLY_FEE ||
        value === ParcelTypeEnum.QUARTERLY ||
        value === ParcelTypeEnum.SEMIANNUAL ||
        value === ParcelTypeEnum.ANNUAL;

      if (value !== ParcelTypeEnum.MONTHLY_FEE) {
        this.calculateParcel();
      } else {
        this.form.get('parcel')?.setValue('');
      }

      this.calculateTotal();
    });

    this.form.get('monthlyValue')?.valueChanges.subscribe(() => {
      this.calculateTotal();
    });

    this.form.get('discountValue')?.valueChanges.subscribe(() => {
      this.calculateTotal();
    });
  }

  ngOnDestroy() {
    this.typeSub?.unsubscribe();
  }

  ngAfterViewInit() {
    this.setFields();
    this.cdr.detectChanges();
  }

  private calculateParcel() {
    let date = new Date();
    let currentMonth = date.getMonth();
    let currentYear = date.getFullYear();
    let firstDueDate = this.form.get('firstDueDate')?.value;
    let type = this.form.get('type')?.value;

    if (type === ParcelTypeEnum.MONTHLY_FEE && !firstDueDate) {
      return;
    }

    const monthsRemaining = this.calculateMonthsRemaining(firstDueDate, currentMonth, currentYear);
    switch (type) {
      case ParcelTypeEnum.MONTHLY_FEE:
        this.form.get('parcel')?.setValue(monthsRemaining);
        break;
      case ParcelTypeEnum.QUARTERLY:
        this.form.get('parcel')?.setValue(3);
        break;
      case ParcelTypeEnum.SEMIANNUAL:
        this.form.get('parcel')?.setValue(6);
        break;
      case ParcelTypeEnum.ANNUAL:
        this.form.get('parcel')?.setValue(12);
        break;
      case ParcelTypeEnum.DEPLOYMENT:
        this.form.get('parcel')?.setValue(1);
        break;
      default:
        this.form.get('parcel')?.setValue(1);
        break;
    }
  }

  private calculateTotal() {
    let value = this.form.get('monthlyValue')?.value ?? 0;
    let parcel = this.form.get('parcel')?.value ?? 0;
    let taxValue = this.form.get('taxValue')?.value ?? 0;
    let discountPercent = this.form.get('discountValue')?.value ?? 0;
    let total = value * parcel;

    total = total - (total * discountPercent) / 100;

    this.form.get('totalPaidValue')?.setValue(total);
  }

  onSubmit(value: { [name: string]: any }) {
    this.dialogRef.close({ element: value });
  }

  onCancel() {
    this.dialogRef.close();
  }

  changeType(type: TypeCesEnum) {
    this.type = type;
    this.dialogRef.close({ changeType: type });
  }

  delete() {
    this.dialogRef.close({ delete: true });
  }

  openDelete(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      data: { title: 'REMOÇÃO' },
      component: DialogConfirmComponent,
      callBack: (data: any) => {
        if (data?.result) {
          this.dataSource.data = this.dataSource.data.filter(
            (item) => item.code !== element.code
          );
        }
      },
    });
  }

  changePage(event: any) {
    this.params.page = event.page;
    this.params.limit = event.limit;
  }

  filter(event: any) {
    this.params.filter = event;
  }

  onSelectionChange($event: any) { }

  openShow(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: CustomerParcelCESComponent,
      data: { type: TypeCesEnum.SHOW, element },
      dialogConfig: {
        minWidth: '600px',
        maxWidth: '800px',
        minHeight: '420px',
        maxHeight: '900px',
        width: 'auto',
        height: 'auto',
      },
      callBack: (data: any) => {
        if (data?.changeType === TypeCesEnum.EDIT) {
          this.openEdit(element);
        }

        if (data?.result) {
          this.openDelete(element);
        }
      },
    });
  }

  openNew(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: CustomerParcelCESComponent,
      data: { type: TypeCesEnum.NEW, element },
      dialogConfig: {
        minWidth: '800px',
        maxWidth: '1800px',
        minHeight: '420px',
        maxHeight: '900px',
        width: 'auto',
        height: 'auto',
      },
      callBack: (data: any) => {
        if (data?.element) {
          let {
            code,
            origin,
            type,
            parcel,
            ourNumber,
            document,
            emissionDate,
            dueDate,
            delayDays,
            value,
            taxValue,
            total,
            status,
          } = data.element;
          let object: ICustomerParcel = {
            code,
            origin,
            type,
            parcel,
            ourNumber,
            document,
            emissionDate,
            dueDate,
            delayDays,
            value,
            taxValue,
            total,
            status,
          };

          this.service.create(Object.assign({}, object)).subscribe(
            () => { },
            (error) => {
              this.openNew(data.element);
            }
          );
        }
      },
    });
  }

  openEdit(element: any) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: CustomerParcelCESComponent,
      data: { type: TypeCesEnum.EDIT, element },
      dialogConfig: {
        minWidth: '700px',
        maxWidth: '900px',
        minHeight: '420px',
        maxHeight: '900px',
        width: 'auto',
        height: 'auto',
      },
      callBack: (data: any) => {
        if (data?.element?.id) {
          let {
            id,
            code,
            origin,
            type,
            parcel,
            ourNumber,
            document,
            emissionDate,
            dueDate,
            delayDays,
            value,
            taxValue,
            total,
            status,
          } = data.element;
          let object: ICustomerParcel = {
            code,
            origin,
            type,
            parcel,
            ourNumber,
            document,
            emissionDate,
            dueDate,
            delayDays,
            value,
            taxValue,
            total,
            status,
          };

          this.service.update(id, Object.assign({}, object)).subscribe({
            next: () => { },
            error: (error) => {
              this.openNew(data.element);
            },
          });
        }

        if (data?.changeType === TypeCesEnum.SHOW) {
          this.openShow(element);
        }

        if (data?.result) {
          this.openDelete(element);
        }
      },
    });
  }

  public addItem(): void {
    const validationResult = this.validateParcelData();

    if (!validationResult.isValid) {
      this.toastService.showWarn(validationResult.message);
      return;
    }

    switch (this.form.value.type) {
      case ParcelTypeEnum.MONTHLY_FEE:
      case ParcelTypeEnum.QUARTERLY:
      case ParcelTypeEnum.SEMIANNUAL:
      case ParcelTypeEnum.ANNUAL:
      case ParcelTypeEnum.DEPLOYMENT:
        this.generateMonthlyFeeParcels(this.form.value);
        break;
      case ParcelTypeEnum.ADHESION:
        this.toastService.showWarn('Tipo Adesão não está implementado');
        return;
      case ParcelTypeEnum.DAYS_COUNT:
        this.toastService.showWarn('Tipo Dias Corridos não está implementado');
        return;
      case ParcelTypeEnum.MANUAL:
        this.generateManualParcel(this.form.value);
        break;
      default:
        this.toastService.showWarn('Selecione um tipo de parcela válido');
        return;
    }

    this.dataSource._updateChangeSubscription();
    this.cdr.detectChanges();

    this.resetFormAfterAddingParcel();
  }

  get parcelTypeEnum() {
    return ParcelTypeEnum;
  }

  /**
   * Valida os dados da parcela antes de adicionar
   * @returns Objeto com isValid e message
   */
  private validateParcelData(): { isValid: boolean; message: string } {
    const type = this.form.value.type;
    const parcel = this.form.value.parcel;
    const firstDueDate = this.form.value.firstDueDate;
    const monthlyValue = this.form.value.monthlyValue;

    // Validação: Tipo de parcela é obrigatório
    if (!type) {
      return {
        isValid: false,
        message: 'Selecione o tipo de parcela',
      };
    }

    // Validação: Número de parcelas é obrigatório
    if (!parcel || parcel <= 0) {
      return {
        isValid: false,
        message: 'Informe o número de parcelas (deve ser maior que zero)',
      };
    }

    // Validação: Data de vencimento é obrigatória
    if (!firstDueDate) {
      return {
        isValid: false,
        message: 'Informe a data do primeiro vencimento',
      };
    }

    // Validação: Valor mensal é obrigatório e deve ser maior que zero
    if (!monthlyValue || monthlyValue <= 0) {
      return {
        isValid: false,
        message: 'Informe o valor da parcela (deve ser maior que zero)',
      };
    }

    // Validação específica: Plano é obrigatório para tipos específicos
    if (this.showSelectPlan && !this.form.value.plan) {
      return {
        isValid: false,
        message: 'Selecione um plano para este tipo de parcela',
      };
    }

    // Validação: Data de vencimento não pode ser muito antiga
    const dueDate = new Date(firstDueDate);
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

    if (dueDate < oneYearAgo) {
      return {
        isValid: false,
        message: 'A data de vencimento não pode ser anterior a 1 ano atrás',
      };
    }

    // Validação: Valores adicionais com datas correspondentes
    const adhesionFee = this.form.value.adhesionFee;
    const adhesionFeeDueDate = this.form.value.adhesionFeeDueDate;

    if (adhesionFee > 0 && !adhesionFeeDueDate) {
      return {
        isValid: false,
        message: 'Informe a data de vencimento da taxa de adesão',
      };
    }

    const deploymentValue = this.form.value.deploymentValue;
    const deploymentDueDate = this.form.value.deploymentDueDate;

    if (deploymentValue > 0 && !deploymentDueDate) {
      return {
        isValid: false,
        message: 'Informe a data de vencimento da implantação',
      };
    }

    const daysCountValue = this.form.value.daysCountValue;
    const daysCountDueDate = this.form.value.daysCountDueDate;

    if (daysCountValue > 0 && !daysCountDueDate) {
      return {
        isValid: false,
        message: 'Informe a data de vencimento dos dias corridos',
      };
    }

    return {
      isValid: true,
      message: '',
    };
  }

  /**
   * Reseta o formulário após adicionar uma parcela
   */
  private resetFormAfterAddingParcel(): void {
    this.form.get('fees')?.setValue(parseFloat((this.originalInterestPercent * 100).toFixed(2)));
    this.form.get('fine')?.setValue(parseFloat((this.originalFineValue * 100).toFixed(2)));

    this.form.patchValue({
      type: '',
      plan: '',
      parcel: '',
      firstDueDate: '',
      monthlyValue: 0,
      adhesionFee: 0,
      adhesionFeeDueDate: '',
      deploymentValue: 0,
      deploymentDueDate: '',
      daysCountValue: 0,
      daysCountDueDate: '',
      discountValue: 0,
    });
  }

  /**
   * Valida os dados antes de salvar as parcelas
   * Inclui validações específicas para geração de boletos
   * @returns Objeto com isValid e message
   */
  private validateBeforeSave(): { isValid: boolean; message: string } {
    const billItems = this.dataSource.data;
    const generateBill = this.form.get('generateBill')?.value;

    // Validação: Deve haver pelo menos uma parcela
    if (!billItems || billItems.length === 0) {
      return {
        isValid: false,
        message: 'Adicione pelo menos uma parcela antes de salvar',
      };
    }

    // Validação: Verificar se o cliente está definido
    if (!this.customer || !this.customerId) {
      return {
        isValid: false,
        message: 'Cliente não identificado. Não é possível gerar parcelas',
      };
    }

    // Validações específicas quando for gerar boletos
    if (generateBill) {
      const customerValidation = this.validateCustomerDataForBoleto();
      if (!customerValidation.isValid) {
        return customerValidation;
      }

      // Validação: Verificar datas de vencimento
      const dateValidation = this.validateDueDates(billItems);
      if (!dateValidation.isValid) {
        return dateValidation;
      }

      // Validação: Verificar valores das parcelas
      const valueValidation = this.validateParcelValues(billItems);
      if (!valueValidation.isValid) {
        return valueValidation;
      }
    }

    return {
      isValid: true,
      message: '',
    };
  }

  /**
   * Valida dados do cliente necessários para geração de boleto
   * @returns Objeto com isValid e message
   */
  private validateCustomerDataForBoleto(): {
    isValid: boolean;
    message: string;
  } {
    console.log('🔍 Validando dados do cliente para boleto:', this.customer);

    // Validação: Documento do cliente
    const document = this.getCustomerDocument();
    console.log('📄 Documento do cliente:', document);
    if (
      !document ||
      document === '00000000000' ||
      document === '00000000000000'
    ) {
      return {
        isValid: false,
        message:
          'Cliente sem documento (CPF/CNPJ) cadastrado. Não é possível gerar boletos',
      };
    }

    // Validação: Nome do cliente
    const name = this.getCustomerName();
    console.log('👤 Nome do cliente:', name);
    if (!name || name === 'Cliente') {
      return {
        isValid: false,
        message: 'Cliente sem nome cadastrado. Não é possível gerar boletos',
      };
    }

    // Validação: Endereço do cliente
    const address = this.customer.address?.trim();
    const city = this.customer.city?.trim();
    const state = this.customer.state?.trim();

    console.log('🏠 Endereço:', { address, city, state });

    if (!address || !city || !state) {
      return {
        isValid: false,
        message:
          'Cliente sem endereço completo (rua, cidade e estado). Atualize o cadastro antes de gerar boletos',
      };
    }

    // Validação: CEP do cliente
    const cep = this.customer.cep?.toString().trim();
    console.log('📮 CEP do cliente:', cep);

    if (!cep || cep === '' || cep === '00000000' || cep === '0') {
      return {
        isValid: false,
        message:
          'Cliente sem CEP cadastrado. Atualize o cadastro antes de gerar boletos',
      };
    }

    console.log(
      '✅ Validação de dados do cliente para boleto concluída com sucesso'
    );

    return {
      isValid: true,
      message: '',
    };
  }

  /**
   * Valida as datas de vencimento das parcelas
   * @param billItems Array de parcelas
   * @returns Objeto com isValid e message
   */
  private validateDueDates(billItems: any[]): {
    isValid: boolean;
    message: string;
  } {
    const invalidDates = billItems.filter((item) => {
      if (!item.dueDate) {
        return true;
      }

      // Validar formato de data
      const dateStr = item.dueDate;
      if (typeof dateStr === 'string') {
        const parts = dateStr.split('/');
        if (parts.length !== 3) {
          return true;
        }

        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);

        if (isNaN(day) || isNaN(month) || isNaN(year)) {
          return true;
        }

        if (day < 1 || day > 31 || month < 1 || month > 12 || year < 2000) {
          return true;
        }
      }

      return false;
    });

    if (invalidDates.length > 0) {
      return {
        isValid: false,
        message: `Existem ${invalidDates.length} parcela(s) com data de vencimento inválida. Verifique as datas`,
      };
    }

    return {
      isValid: true,
      message: '',
    };
  }

  /**
   * Valida os valores das parcelas
   * @param billItems Array de parcelas
   * @returns Objeto com isValid e message
   */
  private validateParcelValues(billItems: any[]): {
    isValid: boolean;
    message: string;
  } {
    const invalidValues = billItems.filter((item) => {
      const value =
        typeof item.value === 'string' ? parseFloat(item.value) : item.value;
      const total =
        typeof item.total === 'string' ? parseFloat(item.total) : item.total;

      return (
        !value ||
        value <= 0 ||
        !total ||
        total <= 0 ||
        isNaN(value) ||
        isNaN(total)
      );
    });

    if (invalidValues.length > 0) {
      return {
        isValid: false,
        message: `Existem ${invalidValues.length} parcela(s) com valor inválido ou zero. Verifique os valores`,
      };
    }

    return {
      isValid: true,
      message: '',
    };
  }

  private generateMonthlyFeeParcels(value: any): void {
    let firstDueDate = new Date(value.firstDueDate);
    let today = new Date();
    let parcel = value.parcel;
    let monthlyValue = value.monthlyValue;
    let discountValuePercent = value.discountValue ?? 0;
    let total = monthlyValue;
    let discountValue = (total * discountValuePercent) / 100;
    total = total - discountValue;
    let origin = value.origin;
    let type = value.type;

    let fees = parseFloat(((value.fees ?? 0) / 100).toFixed(4));
    let fine = parseFloat(((value.fine ?? 0) / 100).toFixed(4));

    for (let i = 0; i < parcel; i++) {
      let dueDate = new Date(firstDueDate);
      dueDate.setMonth(dueDate.getMonth() + i);

      this.dataSource.data.push({
        code: this.dataSource.data.length + 1,
        origin,
        type: type,
        parcel: i + 1,
        ourNumber: '',
        document: '',
        emissionDate: moment(today)?.format('DD/MM/YYYY'),
        dueDate: moment(dueDate)?.format('DD/MM/YYYY'),
        delayDays: '',
        value: monthlyValue,
        discountValue,
        fees,
        fine,
        total: total,
      });
    }

    if (value.adhesionFee > 0) {
      let dueDate = new Date(value.adhesionFeeDueDate);
      this.dataSource.data.push({
        code: this.dataSource.data.length + 1,
        origin,
        type: ParcelTypeEnum.ADHESION,
        parcel: 1,
        ourNumber: '',
        document: '',
        emissionDate: moment(today)?.format('DD/MM/YYYY'),
        dueDate: moment(dueDate)?.format('DD/MM/YYYY'),
        delayDays: '',
        value: value.adhesionFee,
        discountValue: 0,
        total: value.adhesionFee,
      });
    }

    if (value.deploymentValue > 0) {
      let dueDate = new Date(value.deploymentDueDate);
      this.dataSource.data.push({
        code: this.dataSource.data.length + 1,
        origin,
        type: ParcelTypeEnum.DEPLOYMENT,
        parcel: 1,
        ourNumber: '',
        document: '',
        emissionDate: moment(today)?.format('DD/MM/YYYY'),
        dueDate: moment(dueDate)?.format('DD/MM/YYYY'),
        delayDays: '',
        value: value.deploymentValue,
        discountValue: 0,
        total: value.deploymentValue,
      });
    }

    if (value.daysCountValue > 0) {
      let dueDate = new Date(value.daysCountDueDate);
      this.dataSource.data.push({
        code: this.dataSource.data.length + 1,
        origin,
        type: ParcelTypeEnum.DAYS_COUNT,
        parcel: 1,
        ourNumber: '',
        document: '',
        emissionDate: moment(today)?.format('DD/MM/YYYY'),
        dueDate: moment(dueDate)?.format('DD/MM/YYYY'),
        delayDays: '',
        value: value.daysCountValue,
        discountValue: 0,
        total: value.daysCountValue,
      });
    }
  }

  private generateManualParcel(value: any): void {
    let firstDueDate = new Date(value.firstDueDate);
    let today = new Date();
    let parcel = value.parcel;
    let monthlyValue = value.monthlyValue;
    let discountValuePercent = value.discountValue ?? 0;
    let total = monthlyValue;
    let discountValue = (total * discountValuePercent) / 100;
    total = total - discountValue;
    let origin = value.origin;
    let type = value.type;

    let fees = parseFloat(((value.fees ?? 0) / 100).toFixed(4));
    let fine = parseFloat(((value.fine ?? 0) / 100).toFixed(4));

    for (let i = 0; i < parcel; i++) {
      let dueDate = new Date(firstDueDate);
      dueDate.setMonth(dueDate.getMonth() + i);

      this.dataSource.data.push({
        code: this.dataSource.data.length + 1,
        origin,
        type: type,
        parcel: i + 1,
        ourNumber: '',
        document: '',
        emissionDate: moment(today)?.format('DD/MM/YYYY'),
        dueDate: moment(dueDate)?.format('DD/MM/YYYY'),
        delayDays: '',
        value: monthlyValue,
        discountValue,
        fees,
        fine,
        total: total,
      });
    }
  }

  public onSelectPlan(event: any) {
    this.form.get('monthlyValue')?.setValue(event.monthlyValue);
    this.planSelect = event;
    let plan = event;

    let today = new Date();
    let dueDate = new Date();

    dueDate.setDate(plan.dueDate);

    if (dueDate.getDate() < today.getDate()) {
      dueDate.setMonth(dueDate.getMonth() + 1);
      dueDate.setDate(plan.dueDate);
    }

    this.form.get('origin')?.setValue(plan.type);
    this.form.get('firstDueDate')?.setValue(dueDate);
    this.form.get('monthlyValue')?.setValue(plan.monthlyValue);

    this.form.get('adhesionFee')?.setValue(plan.adhesionFee);
    this.form.get('adhesionFeeDueDate')?.setValue(dueDate);

    this.form.get('deploymentValue')?.setValue(plan.deploymentValue);
    this.form.get('deploymentDueDate')?.setValue(dueDate);

    this.form.get('daysCountValue')?.setValue(plan.daysCountValue);
    this.form.get('daysCountDueDate')?.setValue(dueDate);

    this.form.get('discountValue')?.setValue(0);

    this.calculateParcel();
    this.calculateTotal();
  }

  public clear() {
    this.dataSource.data = [];
  }

  public cancel() {
    this.dialogRef.close();
  }

  public save() {
    const validationResult = this.validateBeforeSave();

    if (!validationResult.isValid) {
      this.toastService.showWarn(validationResult.message);
      return;
    }

    const billItems = this.dataSource.data;
    const generateBill = this.form.get('generateBill')?.value;

    const totalAccountValueFromItems = billItems.reduce((sum, item) => {
      const value =
        typeof item.value === 'string' ? parseFloat(item.value) : item.value;
      return sum + (value || 0);
    }, 0);

    const totalPaidValueFromItems = billItems.reduce((sum, item) => {
      const total =
        typeof item.total === 'string' ? parseFloat(item.total) : item.total;
      return sum + (total || 0);
    }, 0);

    this.showObservationModalBeforeSave(
      billItems,
      generateBill,
      totalPaidValueFromItems,
      totalAccountValueFromItems
    );
  }

  private saveParcelsToDatabase(
    billItems: any[],
    generateBill: boolean,
    totalPaidValue: number,
    totalAccountValue: number,
    observation?: string
  ) {
    const formattedDateArray = billItems.map((object) => {
      if (object.dueDate && typeof object.dueDate === 'string') {
        const dateParts = object.dueDate.split('/');

        if (dateParts.length === 3) {
          const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;

          return {
            ...object,
            dueDate: formattedDate,
          };
        }
      }
      return object;
    });

    const convertedBillItems = formattedDateArray.map((item) => ({
      ...item,
      origin: this.convertOriginToNumber(item.origin),
      type: this.convertTypeToNumber(item.type),
    }));

    const billData: any = {
      isActive: true,
      type: 1,
      code: 0,
      customer: { id: this.customerId },
      billItems: convertedBillItems,
      totalAccountValue: totalPaidValue,
      totalPaidValue: totalPaidValue,
      system: this.planSelect?.system?.id,
    };

    if (observation && observation.trim()) {
      billData.observation = observation;
    }

    const savePromise = this.service.create(billData).toPromise();

    savePromise
      .then((savedBill: any) => {
        if (generateBill && savedBill.billItems.length > 0) {
          this.generateBoletos(
            savedBill.billItems,
            totalPaidValue,
            totalAccountValue
          );
        } else {
          this.dialogRef.close({
            billItems: savedBill.billItems,
            totalPaidValue: totalPaidValue,
            totalAccountValue: totalAccountValue,
          });
        }
      })
      .catch((error: any) => {
        console.error('Erro ao salvar parcelas:', error);
        this.toastService.showError(
          'Erro ao salvar parcelas. Tente novamente.'
        );
        this.dialogRef.close({
          billItems: billItems,
          totalPaidValue: totalPaidValue,
          totalAccountValue: totalAccountValue,
        });
      });
  }

  private convertOriginToNumber(origin: string): number {
    return (
      ParcelOriginIdEnum[origin as keyof typeof ParcelOriginIdEnum] ||
      ParcelOriginIdEnum.SISTEMA
    );
  }

  private convertTypeToNumber(type: string): number {
    return (
      ParcelTypeIdEnum[type as keyof typeof ParcelTypeIdEnum] ||
      ParcelTypeIdEnum.MANUAL
    );
  }

  private generateBoletos(
    billItems: any[],
    totalPaidValue: number,
    totalAccountValue: number
  ) {
    if (!this.customer) {
      this.toastService.showError(
        'Dados do cliente não encontrados. Não é possível gerar boletos.'
      );
      this.dialogRef.close({
        billItems: billItems,
        totalPaidValue: totalPaidValue,
        totalAccountValue: totalAccountValue,
      });
      return;
    }

    this.isGeneratingBoletos = true;
    this.totalBoletos = billItems.length;
    this.processedBoletos = 0;
    this.boletoProgressPercentage = 0;
    this.boletoProgressMessage = `Iniciando geração de ${billItems.length} boletos...`;

    this.processBoletoSequentially(
      billItems,
      0,
      [],
      totalPaidValue,
      totalAccountValue
    );
  }

  private processBoletoSequentially(
    billItems: any[],
    currentIndex: number,
    allSuccessful: any[],
    totalPaidValue: number,
    totalAccountValue: number
  ) {
    if (currentIndex >= billItems.length) {
      this.finalizeBoletoGeneration(
        allSuccessful,
        totalPaidValue,
        totalAccountValue
      );
      return;
    }

    const currentItem = billItems[currentIndex];
    const boletoNumber = currentIndex + 1;

    this.processedBoletos = currentIndex;
    this.boletoProgressPercentage =
      (this.processedBoletos / this.totalBoletos) * 100;
    this.boletoProgressMessage = `Gerando boleto ${boletoNumber}/${this.totalBoletos} (Parcela ${currentItem.parcel})...`;

    this.generateSlipForItem(currentItem, currentIndex)
      .then((result) => {
        allSuccessful.push(result);

        this.processedBoletos = currentIndex + 1;
        this.boletoProgressPercentage =
          (this.processedBoletos / this.totalBoletos) * 100;

        setTimeout(() => {
          this.processBoletoSequentially(
            billItems,
            currentIndex + 1,
            allSuccessful,
            totalPaidValue,
            totalAccountValue
          );
        }, 800);
      })
      .catch((error) => {
        console.error(`❌ Erro ao gerar boleto ${boletoNumber}:`, error);

        const errorMessage = error?.message || 'Erro desconhecido';
        this.toastService.showWarn(
          `Erro no boleto ${boletoNumber}: ${errorMessage}`
        );

        this.processedBoletos = currentIndex + 1;
        this.boletoProgressPercentage =
          (this.processedBoletos / this.totalBoletos) * 100;

        setTimeout(() => {
          this.processBoletoSequentially(
            billItems,
            currentIndex + 1,
            allSuccessful,
            totalPaidValue,
            totalAccountValue
          );
        }, 2000);
      });
  }

  private finalizeBoletoGeneration(
    successful: any[],
    totalPaidValue: number,
    totalAccountValue: number
  ) {
    this.isGeneratingBoletos = false;

    if (successful.length > 0) {
      this.toastService.showSuccess(
        `${successful.length} boletos gerados com sucesso!`
      );
    }

    this.showDownloadModal(successful, totalPaidValue, totalAccountValue);
  }

  private generateSlipForItem(item: any, index: number): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.customer) {
        reject(new Error('Dados do cliente não encontrados'));
        return;
      }

      let dueDate = new Date(item.dueDate);
      const today = new Date();
      if (dueDate < today) {
        dueDate = new Date();
        dueDate.setDate(dueDate.getDate() + 1);
      }
      const hasPenalty =
        Number(item.fine) > 0 || Number(item.fees) > 0;

      const instructions = [
        'Atenção à data de vencimento do boleto',
        hasPenalty
          ? `Após o vencimento, cobrar multa de ${(item.fine*100)}% e mora diária de ${(item.fees*100)}%.`
          : '',
      ].filter(Boolean); 

      const customerAddress = this.getCustomerAddress();
      const slipData = {
        installmentId: item.id,
        amount: item.total || item.value,
        dueAt: dueDate.toISOString(),
        description: `Parcela ${item.parcel} - ${item.type}`,
        instructions: instructions,
        payer: {
          name: this.getCustomerName(),
          document: this.getCustomerDocument(),
          address: customerAddress,
        },
        origin: 'PARCEL_GENERATION',
      };

      const linkedBill = true;
      const skipLoad = true;
      this.slipService.createSlip(slipData, linkedBill, skipLoad).subscribe({
        next: (response) => {
          console.log(
            `🔍 Resposta da API para parcela ${item.parcel}:`,
            response
          );
          resolve({ ...response, originalItem: item });
        },
        error: (error) => {
          console.error(
            `Erro ao gerar boleto para parcela ${item.parcel}:`,
            error
          );
          const errorMessage =
            error?.error?.message || error?.message || 'Erro desconhecido';
          reject(new Error(`Parcela ${item.parcel}: ${errorMessage}`));
        },
      });
    });
  }

  private getCustomerName(): string {
    return (
      this.customer?.tradingName ||
      this.customer?.companyName ||
      this.customer?.name ||
      'Cliente'
    );
  }

  private getCustomerDocument(): string {
    const legalPersonality = this.customer?.legalPersonality as any;
    const isPessoaFisica =
      legalPersonality === 1 ||
      legalPersonality === '1' ||
      legalPersonality === 'Pessoa Física';

    if (isPessoaFisica) {
      return this.customer?.cpf || this.customer?.document || '00000000000';
    } else {
      return this.customer?.cnpj || this.customer?.document || '00000000000';
    }
  }

  private getCustomerAddress(): any {
    const result = {
      street: this.customer?.address || 'Rua não informada',
      number: this.customer?.addressNumber?.toString() || 'S/N',
      complement: this.customer?.addressComplement || 'N/A',
      neighborhood: this.customer?.neighborhood || 'Bairro não informado',
      city: this.customer?.city || 'Cidade não informada',
      state: this.customer?.state || 'UF',
      zipCode: this.customer?.cep || '00000000',
    };

    return result;
  }

  private showDownloadModal(
    billItems: any[],
    totalPaidValue: number,
    totalAccountValue: number
  ) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      data: {
        title: 'Boletos Gerados com Sucesso!',
        content: `Foram gerados ${billItems.length} boletos com sucesso.<br><br>Deseja baixá-los?`,
        yesText: 'Baixar Boletos',
        noText: 'Não',
      },
      component: DialogConfirmComponent,
      callBack: async (result: any) => {
        if (result?.result) {
          await this.downloadAllBoletos(billItems);
        }

        this.dialogRef.close({
          billItems: billItems,
          totalPaidValue: totalPaidValue,
          totalAccountValue: totalAccountValue,
        });
      },
    });
  }

  private async fetchPdfBlob(url: string): Promise<Blob> {
    if (url.startsWith('data:')) {
      const response = await fetch(url);
      return response.blob();
    }

    const backendUrl = `${API_PATH}pdf/gerar?url=${encodeURIComponent(url)}`;
    const response = await fetch(backendUrl);

    if (!response.ok) {
      throw new Error(`Erro ao buscar PDF: ${response.statusText}`);
    }

    return response.blob();
  }


  async downloadAllBoletos(generatedSlips: any[]): Promise<void> {

    if (!generatedSlips || generatedSlips.length === 0) {
      this.toastService.showWarn('Nenhum boleto foi gerado para download.');
      return;
    }

    this.isDownloading = true;
    this.downloadTotal = generatedSlips.length;
    this.downloadProgress = 0;

    try {
      if (generatedSlips.length === 1) {
        const slip = generatedSlips[0];
        const dueDate = GlobalUtils.formatDate(slip.dueDate);
        const safeDate = dueDate ? dueDate.replace(/\//g, '-') : '';
        const url = slip.url || slip.originalUrl || slip.viewerUrl;
        const item = slip.originalItem || slip;
        const fileName = `${this.getCustomerName()}_${safeDate}.pdf`;

        if (!url) throw new Error('URL do boleto não encontrada.');

        const blob = await this.fetchPdfBlob(url);
        saveAs(blob, fileName);

        this.downloadProgress = 1;
        this.toastService.showSuccess('Boleto baixado com sucesso!');
      }


      else {
        const zip = new JSZip();
        let successCount = 0;

        for (const [index, slip] of generatedSlips.entries()) {
          const url = slip.url || slip.originalUrl || slip.viewerUrl;
          const dueDate = GlobalUtils.formatDate(slip.dueDate);
          if (!url) {
            console.warn(`Boleto índice ${index} ignorado: Sem URL.`);
            this.downloadProgress++;
            continue;
          }

          try {
            const blob = await this.fetchPdfBlob(url);

            const item = slip.originalItem || slip;
            const safeDate = dueDate ? dueDate.replace(/\//g, '-') : '';
            const fileName = `${index + 1}_${this.getCustomerName()}_${safeDate}.pdf`;

            zip.file(fileName, blob);
            successCount++;

          } catch (innerError) {
            console.error(`Falha ao baixar boleto ${index + 1}:`, innerError);
          }

          this.downloadProgress++;
        }

        if (successCount === 0) {
          throw new Error('Não foi possível baixar nenhum dos boletos.');
        }

        const zipContent = await zip.generateAsync({ type: 'blob' });
        saveAs(zipContent, `${this.getCustomerName()}.zip`);

        if (successCount < generatedSlips.length) {
          this.toastService.showWarn(`Download parcial: ${successCount} de ${generatedSlips.length} boletos baixados.`);
        } else {
          this.toastService.showSuccess('Todos os boletos baixados e compactados!');
        }
      }

      await new Promise(resolve => setTimeout(resolve, 2000));

    } catch (error: any) {
      console.error('Erro no processo de download:', error);
      this.toastService.showError(`Erro ao realizar download: ${error.message}`);

      await new Promise(resolve => setTimeout(resolve, 2000));

    } finally {
      this.isDownloading = false;
      this.downloadProgress = 0;
      this.downloadTotal = 0;
    }
  }


  private loadGlobalConfig(): void {
    if (!this.form) {
      console.error('Formulário não inicializado');
      return;
    }

   this.globalConfigService.getGlobalConfig(GlobalConfigOriginEnum.InterestAndFine).subscribe({
      next: (config: any) => {
        if (config && typeof config === 'object') {
          this.originalInterestPercent =
            config.interest !== undefined && config.interest !== null
              ? config.interest
              : 0;
          this.originalFineValue =
            config.fine !== undefined && config.fine !== null ? config.fine : 0;

          if (this.form.get('fees')) {
            this.form.get('fees')?.setValue(parseFloat((this.originalInterestPercent * 100).toFixed(2)));
          } else {
            console.warn('Campo fees não encontrado no formulário');
          }

          if (this.form.get('fine')) {
            this.form.get('fine')?.setValue(parseFloat((this.originalFineValue * 100).toFixed(2)));
          } else {
            console.warn('Campo fine não encontrado no formulário');
          }

          this.cdr.detectChanges();
        } else {
          console.warn(
            'Configuração global retornou dados inválidos ou vazios:',
            config
          );
          this.toastService.showWarn(
            'Configuração global inválida ou inexistente.'
          );
        }
      },
      error: (error) => {
        this.toastService.showWarn(
          'Não foi possível carregar as configurações globais de juros e multa.'
        );
        console.error('Erro ao carregar configurações globais:', error);
      },
    });
  }

  private showObservationModalBeforeSave(
    billItems: any[],
    generateBill: boolean,
    totalPaidValue: number,
    totalAccountValue: number
  ) {
    GlobalUtils.openDialog({
      dialog: this.dialog,
      data: {
        title: `Observações`,
        typeCes: TypeCesEnum.EDIT,
      },
      component: ReasonDialog,
      callBack: (dataReason: any) => {
        const observation = dataReason?.updateReason || '';

        this.saveParcelsToDatabase(
          billItems,
          generateBill,
          totalPaidValue,
          totalAccountValue,
          observation
        );
      },
    });
  }

  private calculateMonthsRemaining(firstDueDate: string | Date, currentMonth: number, currentYear: number): number {
    if (!firstDueDate) {
      return 12 - currentMonth;
    }

    const dueDate = new Date(firstDueDate);
    const dueMonth = dueDate.getMonth();
    const dueYear = dueDate.getFullYear();

    const isDecemberLookingAtNextJanuary = currentMonth === 11 && dueYear > currentYear && dueMonth === 0;

    if (isDecemberLookingAtNextJanuary) return 12;
    if (dueYear === currentYear) return 12 - dueMonth;
    if (dueYear > currentYear) return 0;

    return 12;
  }
}
